import React, { ReactElement } from 'react';

const WMSOrderPage = (): ReactElement => {
  return <div>WMS Order Page</div>;
};

export default WMSOrderPage;
